import React, { createContext, useState, useEffect } from 'react';
import api from './axiosInstance';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [appointmentData, setAppointmentData] = useState({});
  const [loading, setLoading] = useState(true); // Add loading state
  const [authorizationError, setAuthorizationError] = useState(null);

  useEffect(() => {
    // Attempt to call /api/me using access token from HttpOnly cookie (backend extracts).
    api.get('/api/me')
      .then(res => {
        const { id, email, authenticated, isApplicantPortalUser } = res.data || {};
        if (authenticated && id && isApplicantPortalUser === true) {
          setUser({ id, email });
          setIsAuthenticated(true);
          setAuthorizationError(null);
        } else {
          setUser(null);
          setIsAuthenticated(false);
          setAuthorizationError(authenticated && id ? 'applicant_account_required' : null);
        }
        setLoading(false);
      })
      .catch(() => {
        setIsAuthenticated(false);
        setUser(null);
        setAuthorizationError(null);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    // Logging for updates if needed
    // console.log("AuthContext updated with isAuthenticated:", isAuthenticated);
    // console.log("AuthContext updated with user ID:", user?.id);
  }, [isAuthenticated, user]);

  const login = (email, id, isApplicantPortalUser = false) => {
    if (isApplicantPortalUser !== true) {
      setUser(null);
      setIsAuthenticated(false);
      setAuthorizationError('applicant_account_required');
      setLoading(false);
      return false;
    }
    setUser({ id, email });
    setIsAuthenticated(true);
    setAuthorizationError(null);
    setLoading(false);
    return true;
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, user, setUser, appointmentData, setAppointmentData, login, loading, authorizationError, setAuthorizationError }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext };
export default AuthContext;
